// extracted by mini-css-extract-plugin
export default {"stopButton":"StopGenerateButton_stopButton__29uNi","light":"StopGenerateButton_light__djK8c","dark":"StopGenerateButton_dark__uWACK","stopIcon":"StopGenerateButton_stopIcon__ztmi8"};